import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useAuth = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('access_token');

        if (!token) {
            // Si le token n'est pas présent, rediriger vers la page de connexion
            console.log('token absent');
            navigate('/', { replace: true });
            return; // Arrêter l'exécution ici si le token est absent
        }

        // const timeoutId = setTimeout(() => {
        //     localStorage.removeItem('access_token'); // Supprimer le token
        //     console.log('Token supprimé après 1 heure d\'inactivité');
        //     navigate('/papachigan', { replace: true });
        // }, 3600000); 

        // // Nettoyage du timeout si le composant se démonte ou si l'utilisateur se reconnecte
        // return () => clearTimeout(timeoutId);
    }, [navigate]);
};

export default useAuth;
